export default function searchService($http) {
    const getSearchResults = (query, filter, pageNumber, pageSize) => 
        $http.get('/webapi/sitesearch/GetSearchResults?query=' + query + '&searchType=' + filter + '&page=' + pageNumber + '&count=' + pageSize)
            .then(result => result.data);    

    const getSidebarResults = (query, pageSize) => 
        $http.get('/webapi/sitesearch/GetSidebarResults?query=' + query + '&count=' + pageSize)
            .then(result => result.data);

    return {
        getSearchResults: getSearchResults,
        getSidebarResults: getSidebarResults
    }
}